import { DefaultState } from 'store/types';

export const CLOSE_LODGING_OPTION_REQUEST = 'CLOSE_LODGING_OPTION_REQUEST';
export const CLOSE_LODGING_OPTION_SUCCESS = 'CLOSE_LODGING_OPTION_SUCCESS';
export const CLOSE_LODGING_OPTION_FAILURE = 'CLOSE_LODGING_OPTION_FAILURE';

export interface CloseLodgingOptionData {

};

export type CloseLodgingOptionState = DefaultState & {
  contents?: CloseLodgingOptionData;
};

interface CloseLodgingOptionRequest {
  type: typeof CLOSE_LODGING_OPTION_REQUEST;
};

interface CloseLodgingOptionSuccess {
  type: typeof CLOSE_LODGING_OPTION_SUCCESS,
  contents: CloseLodgingOptionData;
}

interface CloseLodgingOptionFailure {
  type: typeof CLOSE_LODGING_OPTION_FAILURE;
}

export type CloseLodgingOptionActionTypes = CloseLodgingOptionRequest | CloseLodgingOptionSuccess | CloseLodgingOptionFailure;